//=====================================================================
// Create element and add classes and attributes
//=====================================================================
export function createElement(element, classes = [], attributes = {}) {
    const newElement = document.createElement(element);
    classes.forEach(className => newElement.classList.add(className));
    for (let att in attributes) {
        newElement.setAttribute(att, attributes[att]);
    }
    return newElement;
}